// extracted by mini-css-extract-plugin
export default {"inputError":"Error_inputError__9JiF2"};